<template>
  <div fluid class="gray--background pa-3 mb-4" grid-list-md>
    <v-layout row wrap v-if="status === 0 || !status">
      <v-flex xs12 sm10 class="mt-2">
        <span class="caption">Your effort is pending and only visible to you.</span>
      </v-flex>
      <v-flex xs12 sm2 class="center">
        <v-btn class="primary-button" right round @click="onChange('1')">Publish</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="status === 1">
      <v-flex xs12 sm10 class="mt-2">
        <span class="caption">Your Effort is currently Live and available to Users eligible to discover it.</span>
      </v-flex>
      <v-flex xs12 sm2 class="center">
        <v-btn class="primary-button" right round @click="onChange('0')">Pause</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="status === 2">
      <v-flex xs12 sm10 class="mt-2">
        <span class="caption">Your Effort is currently being Completed by Users.</span>
      </v-flex>
      <v-flex xs12 sm2 class="center">
        <v-btn class="primary-button" right round @click="onChange('0')">Pause</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="status === 3">
      <v-flex xs12 sm10 class="mt-2">
        <span class="caption">Your Effort has reached the criteria for being Completed.</span>
      </v-flex>
      <v-flex xs12 sm2  class="center">
        <v-btn class="primary-button" right round @click="onChange('4')">Archive</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="status === 4">
      <v-flex  xs12 sm12 md12 class="mt-2">
        <span class="caption">Your Effort is currently archived.</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    status: [String, Number],
  },
  methods: {
    onChange(status) {
      this.$emit('change', status);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~styles/shared.scss";

.primary-button {
  background: $primary;
  color: white;
  font-family: MuseoSans-900;
  font-size: 16px !important;
  text-align: center;
  padding: 1px;
}
</style>





// WEBPACK FOOTER //
// src/components/TaskEditStatusBar.vue